<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="p-8 login-tabs-container relative w-full" style="min-width: 330px;" >
    <canvas ref="gameqr" class="ptawayqr"/>
    <!-- NOT HOST, WAITING FOR OTHERS-->

    <div v-if="!amItheHost && !gameStarted">
      <h2 class="text-center mb-4" v-if="amIVerified" >You're In!</h2>
      <p class="text-center my-6 font-medium text-xl text-dark" v-if="nameOfHost">You're joining {{ nameOfHost }}'s game of...</p>
      <img class="block mx-auto w-24 h-auto mt-6" src="@/assets/images/game/whoamirs.png"/>
    </div>

    <div v-if="!amItheHost &&!amIVerified && !gameStarted">
      <vs-divider/>
      <p class="text-center">Type your name to join!</p>
      <vs-input size="large" label="Your name" v-validate="'required|max:20'" name="first_name" class="w-full my-6" v-model="imAJoinerName" placeholder="Enter your first name..."/>
      <span class="font-medium block text-danger text-lg mb-4 text-center" v-show="errors.has('first_name')">{{ errors.first('first_name') }}</span>
      <vs-button color="primary" class="w-full" @click="verifyMe($event)">Join Game</vs-button>
    </div>

    <div v-if="!amItheHost &&!amIVerified && gameStarted">
      <h1 class="text-center mt-20">🙃😬😑🙃😬😑🙃😬😑</h1>
      <h2 class="my-10 text-center">Game already started</h2>
      <p class="text-center">This game has already started. You'll need to ask the host to create a new game, or start your own.</p>
      <vs-button class="w-full my-4" href="https://games.remotesocial.io/play/startgame?game=whoami">Start your own game</vs-button>
    </div>

    <div v-if="amItheHost && !gameStarted" class="w-full">
      <h6 class="text-center text-dark font-medium mt-4 mb-10">Great! 🙌👍</h6>
      <div v-if="gameState.gameType === 'video'">
        <h2 class="text-center text-2xl mb-4 leading-normal text-primary font-extrabold">Now, get on a video call with friends, and share the game link to their phones!</h2>        
        <div class="w-full text-center">
          <img src="@/assets/images/phonetopcsmall.png" class="w-full lg:px-10"/>
          <p class="text-center font-normal text-dark my-2 mx-auto max-w-sm leading-normal">Our games work best if everyone <span class="font-bold">video</span> chat on the <span class="font-bold">computer</span> and <span class="font-bold">play</span> from their <span class="font-bold">phones</span> 😀</p>
        </div>
      </div>
      <div v-else>
        <h2 class="text-center text-2xl mb-4 leading-normal">Now, let players scan this QR code, or share the game link to their phones!</h2>        
        <div class="w-full text-center">
          <img v-if="qrImgSrc" :src="qrImgSrc" class="w-full lg:px-10"/>
        </div>
      </div>
    <vs-input label="Game Link" disabled :value="gameLink" class="w-full mt-6 disabledclearvalue"/>
    <vs-button color="secondary" icon-after type="border" @click="copyLink" class="w-full my-2" :icon-pack="copyIcon ? 'feather' : ''" :icon="copyIcon ? copyIcon : ''">{{ copyText }}</vs-button>
    <vs-button class="w-full" @click="showQRPopup = true" type="border" color="secondary">Show QR Code <img v-if="qrImgSrc" :src="qrImgSrc" class="w-6 ml-1 float-right"/></vs-button>
    <vs-popup class="holamundo" title="Join Game QR Code" :active.sync="showQRPopup">
      <p class="my-0 text-center text-light font-normal max-w-xs mx-auto">(Share the below QR Code with other players so they can join the game)</p>
      <img v-if="qrImgSrc" :src="qrImgSrc" class="w-full lg:px-32 mx-auto block"/>
      <p class="mb-2 text-center text-primary font-bold text-xl">Scan with your phone to join!</p>
    </vs-popup>
    <vs-button color="#4FCE5D" icon-after :href="whatsAppLink" class="w-full my-2 sm:hidden" icon-pack="feather" icon="icon-share-2">Share link on Whatsapp</vs-button>
    <!-- HOST, START GAME -->
    <vs-button v-if="amItheHost && !gameStarted" size="large" :disabled="!(playersVerifiedAtStart.length > 1 && gameState.currentTurn === false)" class="w-full mt-2" color="primary" @click="startGame($event)">Start Game!</vs-button>
    <p v-if="!gameStarted" class="my-2 text-center">You can start the game when 2 or more players are in the game! Wait for everyone to join before you start!</p>
    </div>


<!-- HOST AND JOINER, SHOW WHOS JOINED -->
    <div class="my-4" v-if="!gameStarted">
      <label class="vs-input--label">Your Crew</label>
      <div class="block py-8" v-if="!gameState.currentTurn">
        <p class="text-dark font-medium">
          <span v-for="(player,i) in playersVerifiedAtStart" class="block my-1">
              ✔️{{ player.name === myName ? myName + ' (You)' : player.name}}
              <vs-button v-if="amItheHost && player.uid !== myUID" :key="JSON.stringify(playerUIDToNames) + String (player.uid)" size="small" type="border" color="primary" class="inline-block ml-2" @click="removeFromPUTN($event,player.uid)" icon-pack="feather" icon="CopyIcon"> Remove</vs-button>
          </span>
        </p>
      </div>
    <p v-if="!gameStarted && !amItheHost && amIVerified" class="my-2 text-center">Waiting for everyone... {{ nameOfHost}} can start the game when all players have joined.</p>
    <div class="text-dark">
      <vs-divider/>
      <ul class="font-medium">
        <li class="my-3" v-if="!amItheHost">☝️ If you lose the game, <span class="font-bold">enter the way you came</span>.</li>
        <li class="my-3" v-if="amItheHost">☝️ If you lose the game, open the <span class="font-bold">game link</span> in this <span class="font-bold">same browser</span> you hosted from.</li>
        <li>☝️ If you get stuck, <span class="font-bold">refresh your browser.</span></li>
      </ul>
    </div>
  </div>


  <div v-if="gameStarted && amIVerified">
  <div v-if="screenMessageLocal" v-html="screenMessageLocal.html">
  </div>
  <vs-button v-if="screenMessageLocal" type="border" class="w-full my-4" @click="() => {screenMessageLocal = false}">Continue</vs-button>

  <div v-if="gameOver && !screenMessageLocal">
    <h2 class="text-center">Game Over!⚡️</h2>
    <vs-divider class="mt-6" style="opacity: 0.5;"/>
    <div v-for="(player,i) in currentPlayersInSequence">
      <div class="pt_playerblock_grid" :class="{'pt_bg': i % 2 == 0 }">
        <div class="playername">
          <span class="center block font-medium text-dark">{{ player.uid === myUID ? 'You' : player.name }}<br><h4>{{ player.place === false ? getOrdinal(currentPlayersInSequence.length) : player.place === 0 ? getOrdinal(player.place+1) : getOrdinal(player.place) }}</h4></span>
        </div>
        <div class="pic">
          <img v-if="player.character.imgSrc" :src="player.character.imgSrc"/>
        </div>
        <div class="charactername">
         <span class="pl-2 center font-bold text-dark uppercase">{{ player.character.name }}</span>
        </div>
      </div>
    </div>
    <vs-button v-if="amItheHost" size="large" style="transition: none;" class="w-full mt-4" :key="btnsKey + 'ef4'" @click="playAgain($event)">Play Again ></vs-button>
    <p v-else class="my-2 text-center">Keen for another round? The host can start another by selecting "Play Again".</p>
  </div>


  <div v-if="!screenMessageLocal && !gameOver" :key="gameState.turnNo + 'sdf'" >
  <div class="" v-if="!isMyTurn">
    <p class="leading-thrice text-center" v-if="gameState.turnNo === 0">Game Started!⚡️</p>
    <h2 class="text-center mt-4 mb-8 text-5xl">{{ currentPlayerTurn.name }}'s Turn!</h2>
    <div class="pt_charblock">
      <div class="imgblock">
        <img v-if="currentPlayerTurn.character.imgSrc" :src="currentPlayerTurn.character.imgSrc"/>
      </div><div class="textblock">
        <div class="text pl-4">
          <p class="text-sm">{{ currentPlayerTurn.name }} is...</p>
          <h3 class="uppercase">{{ currentPlayerTurn.character.name }}</h3>
        </div>
      </div>
    </div>
    <p class="text-center text-xl my-4">{{ currentPlayerTurn.name }} needs to figure out who they are by asking "yes or no" questions!</p>
    <p class="text-center font-normal mb-6">They get 3 questions per turn.</p>
    <p v-if="isDrinkingGame" class="text-center text-xl my-4">For every "no", they take a drink!</p>
    <vs-collapse type="margin" :open-hover="true" class="small block w-full" >
      <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevron-down">
        <div slot="header">
          How to Play
        </div>
        <div class="text-dark">
          <p class="text-center mb-0">{{ currentPlayerTurn.name }} is unaware of their assigned famous character or person, and needs to figure who they are!</p>
          <p class="my-4">For their turn, {{ currentPlayerTurn.name }} can ask <span class="font-bold">3 questions</span> that may only be answered with
          <span class="font-bold">"YES"</span> or <span class="font-bold">"NO"</span> by the other players.</p>
          <p class="my-4 text-center text-xl" v-if="isDrinkingGame">For every <span class="font-bold">"NO"</span> answer, {{ currentPlayerTurn.name }} <span class="font-bold">takes a drink!🍻</span></p>
          <p>After 3 questions it's the next player's turn and {{ currentPlayerTurn.name }} has to end their turn by selecting "I'm Done"!</p>
          <p class="my-4">Players can only guess who they "are" in their turns, by clicking the "Guess Who I Am" button!</p>
        </div>
      </vs-collapse-item>
    </vs-collapse>
    <p class="text-center my-4">💡{{ currentPlayerTurn.name }} has {{ currentTurnGuessesLeft }} guess{{ currentTurnGuessesLeft === 1 ? '':'es' }}  left</p>
  </div>

  <div v-if="isMyTurn && gameStarted" class="mt-4">
    <p class="leading-thrice text-center mb-3" v-if="gameState.turnNo === 0">Game Started!⚡️</p>
    <p class="text-center text-5xl">☝</p>
    <h2 class="text-center mt-2 mb-8 text-5xl">Your Turn!</h2>
    <p class="text-center text-xl my-4">Figure out who you are by asking "yes or no" questions. </p>
    <p class="text-center font-normal">You get 3 questions per turn. </p>
    <p class="text-center font-normal">Tap "I'm Done" to to move to the next player.</p>
    <div class="pt_charblock">
      <div class="imgblock">
        <span class="eyes">👀</span>
      </div>
      <div class="textblock">
        <div class="text pl-4">
            <p class="text-sm">Who am I...</p>
            <h3 class="uppercase">???</h3>
        </div>
      </div>
    </div>
    <div class="text-center" v-if="giveTips !== false">
      <vs-divider/>
      <span class="text-primary">Tip{{ giveTips === 1 ? '':'s' }} unlocked!</span>
      <p class="text-dark">✔️Your character/person starts with <span class="font-bold text-xl">"{{myCharacter[0]}}" </span>🤔😀</p>
      <p class="text-dark" v-if="giveTips === 2">✔️Your character/person ends with <span class="font-bold text-xl">"{{myCharacter[myCharacter.length - 1]}}"</span>!</p>
      <vs-divider/>
    </div>
    <vs-collapse v-if="!makeAGuess" type="margin" :open-hover="true" class="small block w-full mt-4" >
      <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevron-down">
        <div slot="header">
          How to Play
        </div>
        <span class="text-dark">
          <p class="text-center mb-0">You have been assigned a secret famous character or person! Only the other players can see who you "are".</p>
          <p class="text-xl text-center my-4 ">You need to figure out who you are!</p
          <br>For your turn you can now ask <span class="font-bold">3 questions</span> that may only be answered with
          <span class="font-bold">"YES"</span> or <span class="font-bold">"NO"</span> by the other players.
          <p class="my-4 text-center text-xl" v-if="isDrinkingGame">For every <span class="font-bold">"NO"</span> answer, you <span class="font-bold">take a drink!🍻</span></p>
          <p class="my-4">Select "I'm Done" when you've asked your 3 questions for your turn to end.</p>
          <p class="my-4">If you suspect you know who you are, you can make a guess by selecting the "Guess Who I Am" button!.</p>
        </span>
      </vs-collapse-item>
    </vs-collapse>

    <vs-button v-if="!makeAGuess" type="border" size="large" color="blue" style="transition: none;" :key="btnsKey + 'vre'" class="w-full my-2 nohover" @click="() => { makeAGuess = true; btnsKey++ }">Guess Who I Am</vs-button>
    <vs-button size="large" v-if="!makeAGuess && iNeedToSayImDone" style="transition: none;" class="w-full my-2" :key="btnsKey" @click="sayImDoneOrGuess($event, false)">I'm Done, Next Player ></vs-button>

    <vs-divider v-if="makeAGuess"/>
    <p v-if="makeAGuess" class="mt-2">Guess the name of your hidden famous character or celebrity:</p>
    <vs-input v-if="makeAGuess" @focus="() => { dontScroll = true  }" @blur="() => { dontScroll = false  }" label="Make a guess" class="w-full mb-1" v-model="myGuess" placeholder="i.e. Elvis Presley"/>
    <p v-if="makeAGuess" class="text-sm mb-2">Psst! Type the full name of your character i.e. "Elvis Presley", not "Elvis".</p>
    <vs-button class="w-1/2 nohover" :key="btnsKey + 'e32'" v-if="makeAGuess" type="border" style="transition: none;"  @click="() => { myGuess = ''; makeAGuess = false; btnsKey++ }" color="blue">Cancel X</vs-button>
    <vs-button class="w-1/2" :key="btnsKey +'mel'" v-if="makeAGuess" style="transition: none;" :disabled="myGuess.trim().length === 0" @click="sayImDoneOrGuess($event, true)">Guess!</vs-button>

    <p class="text-center mt-4">💡You have {{ currentTurnGuessesLeft }} guess{{ currentTurnGuessesLeft === 1 ? '':'es' }} left</p>
    </div>


  <vs-divider class="mt-6" style="opacity: 0.9;"/>
  <label class="vs-input--label">My Notepad</label>
  <vs-textarea counter="700" @focus="() => { dontScroll = true  }" @blur="() => { dontScroll = false  }" placeholder="Is female... Is non-fictional... Is still alive..." v-model="myNotes" class="w-full pt_textarea" />
  <vs-divider class="mt-6" style="opacity: 0.9;"/>


  <label class="vs-input--label">Players</label>

  <div v-for="(player,i) in currentPlayersInSequence">
    <div class="pt_playerblock_grid" :class="{'pt_bg': i % 2 == 0 }">
      <div class="playername">
        <span class="center font-medium text-dark">{{ player.uid === myUID ? 'You' : player.name }}
          <br><h4>{{ player.place === false ? '💡' + String(guessesAllowed - player.guesses.length) : player.place === 0 ? getOrdinal(player.place+1):getOrdinal(player.place) }}</h4></span>
      </div>
      <div class="pic">
        <img v-if="player.uid !== myUID && player.character.imgSrc || player.place !== false" :src="player.character.imgSrc"/>
        <span v-if="player.uid === myUID && player.place === false">👀</span>
      </div>
      <div class="charactername">
       <span class="pl-2 center font-bold text-dark uppercase">{{ player.uid === myUID && player.place === false ? '???' : player.character.name }} {{ player.place !== false ?  '✅':'' }}</span>
      </div>
    </div>
  </div>

  <vs-divider class="mt-6" style="opacity: 0.9;"/>
  <p class="font-normal text-light text-center">*You can only guess who you "are" when it's your turn!*</p>

  <vs-button v-if="amItheHost && !isMyTurn" :key="String(gameState.turnNo) + 'erfwe'" type="flat" class="w-full font-normal mt-4" icon-pack="feather" icon="icon-arrow-right" icon-after @click="skipTurn($event)">Skip {{ currentPlayerTurn.name }}'s turn</vs-button>
  <div v-if="amItheHost && !isMyTurn">
    <div v-if="!iWantToRemovePlayer">
    <vs-button type="flat" class="w-full font-normal" icon-pack="feather" icon="icon-x-circle" @click="removeFromGame({
      uid: currentPlayerTurn.uid,
      name: currentPlayerTurn.name
      })">Remove {{ currentPlayerTurn.name }}</vs-button>
    </div>
    <div v-else class="font-normal text-dark">
      <div v-if="removeMsg"  class="my-5">
        <p>{{ removeMsg }}</p>
        <vs-button class="w-full my-2" @click="() => {
          removeMsg = false; iWantToRemovePlayer = false
          }">Ok</vs-button>
      </div>
      <div v-else>
      <p class="max-w-xs mx-auto my-1 text-center">Are you sure you want to remove {{ iWantToRemovePlayer.name }} from this game? They won't be able to re-join.</p>
      <div class="overflow-auto">
        <vs-button type="border" class="float-left w-1/2" @click="() => {
          iWantToRemovePlayer = false
          }">No</vs-button>
        <vs-button class="float-left w-1/2" @click="confirmRemoveFromGame">Yes</vs-button>
      </div>
      </div>
    </div>
  </div>
  <div v-if="!iWantToLeave">
    <vs-button type="flat" class="w-full font-normal " icon-pack="feather" icon="icon-x-circle" @click="iWantToLeaveTheGame">Leave Game</vs-button>
  </div>
  <div class="mt-4 font-normal text-dark" v-else >

    <div v-if="leaveMsg" class="my-5">
      <p>{{ leaveMsg }}</p>
      <vs-button class="w-full my-2" @click="() => {
        leaveMsg = false; iWantToLeave = false
        }">Ok</vs-button>
    </div>
    <div v-else>
      <p class="max-w-xs mx-auto my-1 text-center">Are you sure you want to leave this game? You won't be able to re-join.</p>
      <div class="overflow-auto">
        <vs-button type="border" class="float-left w-1/2" @click="() => {
          iWantToLeave = false
          }">No</vs-button>
          <vs-button class="float-left w-1/2" @click="confirmLeaveGame">Yes</vs-button>
        </div>
     </div>

  </div>


  </div>
  </div>
  </div>
</template>


<script>

//
//<br>💡{{ guessesAllowed - player.guesses.length }}</span>
//
//


import { mapGetters } from 'vuex'

//import axios from 'axios'

import debounce from 'debounce'

import qrCode from 'qrcode'

import nosleep from 'nosleep.js'

import { Validator } from 'vee-validate'

const dict = {
  custom: {
    first_name: {
      required: 'Your first name is required to play!',
      max: 'Your first name can\'t be longer than 20 characters.'
    }
  }
}

Validator.localize('en', dict)

function fallbackCopyTextToClipboard (text) {
  const textArea = document.createElement('textarea')
  textArea.value = text

  // Avoid scrolling to bottom
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    const successful = document.execCommand('copy')
    const msg = successful ? 'successful' : 'unsuccessful'
  } catch (err) {

  }

  document.body.removeChild(textArea)
}
function copyTextToClipboard (text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text)
    return
  }
  navigator.clipboard.writeText(text).then(function () {
  }, function (err) {
  })
}

export default {
  mounted () {
    if (this.gameLink) {
      this.generateQR()
    }
  },
  data () {
    return {
      myNumber: '',
      dontScroll: false,
      makeAGuess: false,
      windowLocation: window.location.href,
      screenMessageLocal: false,
      copyText: 'Copy Link',
      btnsKey: 0,
      copyIcon: 'icon-copy',
      imAJoinerName: '',
      qrImgSrc: false,
      myNotes: '',
      showQRPopup: false,
      iWantToRemovePlayer: false,
      removeMsg: false,
      leaveMsg: false,
      iWantToLeave: false,
      myGuess: '',
      haveCheckedForExistingNotes: false,
      charSequenceWikiData: []
    }
  },
  watch: {
    gameLink (v) {
      if (v) {
        if (!this.qrImgSrc) {
          this.generateQR()
        }
      }
    },
    currentPlayersInSequence (v) {
      //this is to ensure that I cant view a game that I've been removed from
      //its related to removing a player (we dont want to delete player from playerUIDToNames because it causes kak)
      if (v) {
        let imInThere = false
        v.forEach((pl, i) => {
          if (this.myUID === pl.uid) imInThere = true
        })
        if (!imInThere) {
          window.location.href = 'https://remotesocial.io'
        }
      }
    },
    'gameState.hostUID' (newv, oldv) {
      if (oldv !== false && typeof oldv !== 'undefined') {
        //tell the new host that they can make changes
        if (newv === this.myUID) {
          this.$vs.notify({
            title: 'You\'re the host!',
            text: 'The host left the game and you are the new host! You can now skip turns or remove players.',
            time: 60000
          })
        }
      }
    },
    gameStarted (v) {
      if (v) {
        this.scrollToTop()
      }
    },
    gameLink (v) {
      if (v) {
        const this2 = this
        qrCode.toCanvas(this.$refs.gameqr, this2.gameLink, function (error) {
          if (error) console.error(error)
          //console.log('success!');
          //console.log(this2.$refs.gameqr.toDataURL())
          this2.qrImgSrc = this2.$refs.gameqr.toDataURL()
        })
      }
    },
    myNotes (v) {
      if (this.haveCheckedForExistingNotes) {
        this.debounceNotesInput(v)
      }
    },
    gameID (v) {

      if (!this.haveCheckedForExistingNotes) {

        this.$store.dispatch('whoAmI/checkForLoadNotes').then((doc) => {
          this.myNotes = this.myNotes === '' ? doc.myNotes : `${this.myNotes  }\n${  doc.myNotes}`
        }).catch((e) => {
        //console.log(e)
        })

        this.myNotes = this.myNotes
        this.haveCheckedForExistingNotes = true

      //console.log(this.haveCheckedForExistingNotes)

      }
    },
    screenMessage (v) {
      this.screenMessageLocal = v
      if (!this.gameOver) {
        setTimeout(() => {
          this.screenMessageLocal = false
        }, 12000)
      }
    },
    currentPlayerTurn () {
      //console.log('TURN CHANGED')
      if (!this.dontScroll) {
        this.scrollToTop()
      }
    },
    gameState (v) {
      /*if (v.turnNo === 20 || v.turnNo === 60 || v.turnNo === 100) {
          this.$store.commit('SET_SHOW_FOLLOW')
        }*/
      if (v.gameOver) {
        /*setTimeout(() => {
            this.$store.commit('SET_SHOW_FOLLOW')
          }, 30000)*/
      }
    }
  },
  computed: {
    giveTips () {
      if (this.gameState.turnNo === 0) return false
      const diff = Math.floor(Number(this.gameState.turnNo) / Number(this.currentPlayersInSequence.length))
      if (diff > 4 && diff < 7) {
        return 1
      } else if (diff >= 7) {
        return 2
      }
      return false
    },
    currentTurnGuessesLeft () {
      return this.guessesAllowed - this.currentPlayerTurn.guesses.length
    },
    whatsAppLink () {
      if (this.gameID && this.gameLink) {
        return `whatsapp://send?text= Join my game of "Who am I?" on Remote Social: ${  this.gameLink}`
      }
      return false
    },
    ...mapGetters({
      isDrinkingGame: 'whoAmI/isDrinkingGame',
      screenMessage: 'whoAmI/screenMessage',
      myCharacter: 'whoAmI/myCharacter',
      currentPlayersInSequence: 'whoAmI/currentPlayersInSequence',
      gameFinished: 'whoAmI/gameFinished',
      someOneNeedsToDoThis: 'whoAmI/someOneNeedsToDoThis',
      gameLink: 'whoAmI/gameLink',
      guessesAllowed: 'whoAmI/guessesAllowed',
      amIVerified: 'whoAmI/amIVerified',
      currentPlayerTurn: 'whoAmI/currentPlayerTurn',
      gameStarted: 'whoAmI/gameStarted',
      gameOver: 'whoAmI/gameOver',
      myName: 'whoAmI/myName',
      nameOfHost: 'whoAmI/nameOfHost',
      iNeedToSayImDone: 'whoAmI/iNeedToSayImDone',
      isMyTurn: 'whoAmI/isMyTurn',
      myUID: 'whoAmI/myUID',
      playersVerifiedAtStart: 'whoAmI/playersVerifiedAtStart',
      gameID: 'whoAmI/gameID',
      gameState: 'whoAmI/currentGameState',
      amItheHost: 'whoAmI/amItheHost'
    })
  },
  methods: {
    removeFromPUTN ($event, uid) {
      
      this.makeBtnLoading($event, 'Removing...')

      this.$store.dispatch('removePlayerFromGame', {
        gameType: 'whoami',
        gameID: this.gameID,
        removeUID: uid
      }).then((result) => {
       
      }).catch((e) => {
        //console.log(e)
      })

    },
    generateQR () {
      const this2 = this
      //console.log(this.$refs.gameqr)
      //console.log(this.gameLink)
      qrCode.toCanvas(this.$refs.gameqr, this.gameLink, function (error) {
        if (error) console.error(error)
        //console.log('success!');
        //console.log(this2.$refs.gameqr.toDataURL())
        this2.qrImgSrc = this2.$refs.gameqr.toDataURL()
      })
    },
    skipTurn ($event) {
      this.makeBtnLoading($event, 'Skipping...')
      this.$store.dispatch('whoAmI/skipOrRemove', {
        action: 'skip'
      }).then((result) => {
      //console.log(result)
      })
    },
    confirmLeaveGame () {
      this.$vs.loading()
      this.$store.dispatch('whoAmI/skipOrRemove', {
        removeUID: this.myUID,
        action: 'remove'
      }).then((result) => {
      //console.log(result)
        if (result.data === 'only2') {
          this.leaveMsg = 'Woops! You can\'t leave the game - there\'s only 2 players left.'
        } else {
          window.location.href = 'https://www.remotesocial.io'
        }
      }).catch((e) => {
      //console.log(e)
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    confirmRemoveFromGame () {
      this.$vs.loading()
      this.$store.dispatch('whoAmI/skipOrRemove', {
        removeUID: this.iWantToRemovePlayer.uid,
        action: 'remove'
      }).then((result) => {
        if (result.data === 'only2') {
          this.removeMsg = 'Woops! You can\'t remove someone from the game - there\'s only 2 players left.'
        } else {
          this.removeMsg = false
          this.iWantToRemovePlayer = false
          this.$vs.notify({
            title: 'Player removed.',
            text: '',
            time: 60000
          })
        }

      }).catch((e) => {
      //console.log(e)
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    iWantToLeaveTheGame () {
      //i want to leave
      this.iWantToLeave = true
      this.iWantToRemovePlayer = false
    },
    removeFromGame (playerObj) {
      this.iWantToRemovePlayer = playerObj
      this.iWantToLeave = false
    },
    debounceNotesInput: debounce(function (val) {
      //console.log(val)

      this.$store.dispatch('whoAmI/saveMyNotes', {myNotes: this.myNotes}).then(() => {
      //console.log('notes saved')
      }).catch((e) => {
      //console.log(e)
      })

    }, 5000),
    playAgain ($event) {
      this.$store.dispatch('whoAmI/startGame', {
        resetGame: true
      }).then((result) => {

      }).catch((e) => {
      //console.log(e)
      })
    },
    getOrdinal (n) {
      let s = ['th', 'st', 'nd', 'rd'],
        v = n % 100
      return n + (s[(v - 20) % 10] || s[v] || s[0])
    },
    makeBtnLoading ($event, msg) {
    //console.log($event)
      const srcEl = $event.srcElement
      if (typeof msg === 'undefined') {
        const msg = 'Hold on...'
      }
      srcEl.innerHTML = msg
      srcEl.setAttribute('disabled', 'true')
    },
    copyLink () {
      this.copyText = 'Copied!'
      this.copyIcon = false
      copyTextToClipboard(this.gameLink)
    },
    sayImDoneOrGuess ($event, isGuess) {


      let myGuess = false
      if (this.myGuess.trim().length > 0 && isGuess) {
        myGuess = this.myGuess.trim()
        this.makeBtnLoading($event, 'Checking...')
      } else {
        this.makeBtnLoading($event, 'Connecting to other players...')
      }
      //console.log('dping:' + myGuess)
      this.$store.dispatch('whoAmI/sayImDoneOrGuess', {
        myGuess
      }).then(() => {
        this.makeAGuess = false
        this.btnsKey++
      }).catch((e) => {
        this.makeAGuess = false
        this.btnsKey++
      })
      this.myGuess = ''
    },
    startGame ($event) {

      const noSleep = new nosleep()
      noSleep.enable()

      this.makeBtnLoading($event, 'Connecting to others...')
      this.$store.dispatch('whoAmI/startGame', {
        resetGame: false
      }).then((result) => {

      }).catch((e) => {
        window.location.reload()
      //console.log(e)
      })
    },
    verifyMe ($event) {
      this.$validator.validateAll().then(result => {
        if (result) {

          //check all RS parameters are present
          let allParamsOk = true
          if (typeof this.$route.query.uid === 'undefined' || typeof this.$route.query.accountId === 'undefined') allParamsOk = false
          if (!allParamsOk) {
            this.$vs.notify({
              title: 'Oops!',
              text: 'Something went wrong with joining this game. Taking you back to Remote Social...',
              time: 60000
            })
            setTimeout(() => {
              window.location.href = 'https://hub.remotesocial.io'
            }, 5000)
            return
          }
          //checks done

          const noSleep = new nosleep()
          noSleep.enable()

          this.$vs.loading()

          //call the FB function to add me to the game here
          this.$store.dispatch('whoAmI/verifyMyName', {
            nameProvided: this.imAJoinerName,
            gameID: this.gameID,
            rsUID: decodeURIComponent(this.$route.query.uid),
            rsAccountID: decodeURIComponent(this.$route.query.accountId)
          }).then((result) => {
            this.scrollToTop()
            this.$vs.loading.close()

            //console.log(result)

            if (result.data.verified) {
              /*console.log('verified, sying that Im online')
              this.$store.dispatch('whoAmI/startIAmOnline', {
                gameID: this.gameID
              })
              this.$store.dispatch('whoAmI/startCheckingWhosOnline')*/
            } else {
            //console.log('I wasnt invited?')
              this.$vs.loading.close()
            }
            //do something
          }).catch((e) => {
            window.location.reload()
            //console.log(e)
            //console.log(e)
          })

        }
      })
    }
  },
  created () {

    if (typeof this.$route.query.displayName !== 'undefined') {
      this.imAJoinerName = decodeURIComponent(this.$route.query.displayName)
    }

    /*

    GET IMAGE URLS

            let characters = [
              'Godzilla',
              'King_Kong',
              'Simba',
              'Elvis_Presley',
              'Michael_Jackson',
              'Michael_Jordan',
              'Oprah_Winfrey',
              'Leonardo_DiCaprio',
              'Steven_Spielberg',
              'Harrison_Ford',
              'C%C3%A9line_Dion',
              'Robin_Williams',
              'Tom_Hanks',
              'Tiger_Woods',
              'Cher',
              'Tom_Cruise',
              'Britney_Spears',
              'Michael_Jordan',
              'Mel_Gibson',
              'Jennifer_Aniston',
              'Johnny_Depp',
              'Elton_John',
              'Brad_Pitt',
              'Beyonc%C3%A9',
              'Angelina_Jolie',
              'Jay-Z',
              'Lady_Gaga',
              'Justin_Bieber',
              'Taylor_Swift',
              'Rihanna',
              'Kim_Kardashian',
              'Roger_Federer',
              'Ellen_DeGeneres',
              'Floyd_Mayweather,_Jr.',
              'Katy_Perry',
              'Cristiano_Ronaldo',
              'Adele',
              'George_Clooney',
              'Ed_Sheeran',
              'Donald_Trump',
              'Barack_Obama',
              'Eminem',
              'Adolf_Hitler',
              'Steve_Jobs',
              'Freddie_Mercury',
              'Darth_Vader',
              'Dwayne_Johnson',
              'Harry_Potter',
              'Albert_Einstein',
              'Kanye_West',
              'Mark_Zuckerberg',
              'John_F._Kennedy',
              'Arnold_Schwarzenegger',
              'Pablo_Escobar',
              'Muhammad_Ali',
              'Bill_Gates',
              'Keanu_Reeves',
              'Miley_Cyrus',
              'Abraham_Lincoln',
              'John_Lennon',
              'Mike_Tyson',
              'Rafael_Nadal',
              'Conor_McGregor',
              'Michael_Phelps',
              'Serena_Williams',
              'Novak_Djokovic',
              'David_Beckham',
              'George_W._Bush',
              'Nelson_Mandela',
              'Winston_Churchill',
              'Diana,_Princess_of_Wales',
              'Bill_Clinton',
              'Joseph_Stalin',
              'Osama_bin_Laden',
              'Vladimir_Putin',
              'Julius_Caesar',
              'Robin_Hood',
              'Captain_America',
              'Jack_Sparrow',
              'Cinderella',
              'Zoolander',
              'Shrek',
              'Spider-Man',
              'Buzz_Lightyear',
              'Iron_Man',
              'Joker_(character)',
              'Zorro',
              'Popeye',
              'Batman',
              'Catwoman',
              'Aquaman',
              'Wonder_Woman',
              'Hulk',
              'Hercules_(Marvel_Comics)',
              'The_Wolverine_(film)',
            ]

            let gets = []
            characters.forEach((c) => {
              gets.push(
                axios.get('https://en.wikipedia.org/w/api.php?action=query&prop=pageimages&format=json&piprop=original&titles=' + c)
              )
            })

            let realDeal = []

            axios.all(gets).then(axios.spread((...responses) => {
                //console.log(responses)


                responses.forEach((r,i) => {
                //console.log(i)
                  //console.log(r.data)
                  let ar = Object.keys(r.data.query.pages)
                  ar.forEach((page) => {
                    let obj = {
                      wikiHandle: characters[i],
                      name: r.data.query.pages[page].title,
                      imgSrc: typeof r.data.query.pages[page].original !== "undefined" ? r.data.query.pages[page].original.source :'',
                      width: typeof r.data.query.pages[page].original !== "undefined" ? r.data.query.pages[page].original.width :'',
                      height: typeof r.data.query.pages[page].original !== "undefined" ? r.data.query.pages[page].original.height :'',
                    }
                  //console.log(obj)
                    realDeal.push(obj)
                  })

                })


              })).catch(errors => {
              //console.log(errors)
              })

              window.realDeal = realDeal
            //console.log(realDeal)

    */


    this.screenMessageLocal = false
    const thisRoute = this.$route
    //check if game was just created by me, else it's a fresh load
    if (this.$store.state.whoAmI.gameID) {
    //console.log('host created, connection already made')
      /*this.$store.dispatch('whoAmI/startIAmOnline', {
        gameID: this.gameID
      })
      this.$store.dispatch('whoAmI/startCheckingWhosOnline')*/
      this.$vs.loading.close()
    } else {
      this.$vs.loading()
      //this is someone joining, or someone refreshing
      //console.log('loggin in')
      this.$store.dispatch('auth/registerUserAnonymous').then(() => {
        //look for game
        const gameID = thisRoute.query.gameId ? thisRoute.query.gameId : false
        //sync state
        if (!gameID) {
          window.location.href = 'https://hub.remotesocial.io'
        } else {
          this.$store.dispatch('whoAmI/syncState', {docID: gameID}).then(() => {
          //console.log('game ready to go, now need to verify')
            this.$vs.loading.close()
          }).catch((e) => {
            //bad game ID, reroute to 'this game doesn't exist page'
            window.location.reload()
          //console.log(e)
          })
        }
      }).catch((e) => {
      //console.log(e)
      })
    }
  }
}
</script>

<style lang="scss">


.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
